export default class Cache {

  constructor(url, result = {}, time) {
    this.url = url;
    this.data = JSON.parse(JSON.stringify(result.data));
    this.params = result.config.params;
    this.isCached = true;
    this.time = time || new Date().getTime();
  }

  isExpired() {
    return (new Date().getTime() - this.time) > Cache.LIFE_TIME;
  }

  clone() {
    return new Cache(this.url, {data: this.data, config: {params: this.params}}, this.time);
  }
}

Cache.LIFE_TIME = 180000; // 3 minutes



// WEBPACK FOOTER //
// ./src/app/core/cache/cache.model.js